export const arrayify = <T>(data?: T | T[] | null): T[] => (Array.isArray(data) ? data : data ? [data] : [])
